import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollCreateOrUpdatePerquisitesComponentResponse,
  PayrollCreatePerquisitesComponentInput,
} from './types';

export const createPerquisitesComponentMutation = gql`
  mutation PayrollCreatePerquisiteComponents($components: [CreatePerquisiteComponentInput!]!) {
    payrollCreatePerquisiteComponents(components: $components) {
      code
      message
      success
      data {
        id
        name
        displayName
        description
        isSystemDefault
        status
        showZero
        visibleToEmployee
        taxDeductionBehaviour
      }
    }
  }
`;

const createPerquisitesComponent = (queryVariables: PayrollCreatePerquisitesComponentInput) => {
  return graphQLApi<
    PayrollCreateOrUpdatePerquisitesComponentResponse,
    PayrollCreatePerquisitesComponentInput
  >({
    query: createPerquisitesComponentMutation,
    queryVariables,
  });
};

export default createPerquisitesComponent;
